var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvangardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 207,
    viewBox: "0 0 175 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9199 162.565H6.79479L5.64724 165.905H0.320557L7.63404 146.705H13.0806L20.3941 165.905H15.0674L13.9199 162.565ZM12.6011 158.78L10.3573 152.391L8.11362 158.78H12.6011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6523 146.705H33.0857C34.8499 146.705 36.1858 147.133 37.1107 147.972C38.0356 148.828 38.4809 150.045 38.4809 151.638C38.4809 152.613 38.3096 153.401 37.9671 154.053C37.6246 154.686 37.0936 155.234 36.3742 155.662C37.0936 155.8 37.693 156.004 38.1897 156.279C38.6864 156.553 39.0975 156.896 39.4058 157.307C39.7141 157.717 39.9368 158.18 40.0738 158.676C40.2108 159.191 40.2793 159.739 40.2793 160.303C40.2793 161.211 40.1252 161.999 39.8168 162.702C39.5085 163.404 39.0633 163.987 38.498 164.466C37.9329 164.946 37.2306 165.305 36.4256 165.528C35.6207 165.75 34.6957 165.887 33.6681 165.887H25.6523V146.705ZM30.6536 154.241H31.5785C33.1371 154.241 33.925 153.624 33.925 152.391C33.925 151.157 33.1371 150.524 31.5785 150.524H30.6536V154.241ZM30.6536 162.034H31.7498C33 162.034 33.9078 161.879 34.4559 161.554C35.004 161.229 35.278 160.715 35.278 159.995C35.278 159.276 35.004 158.763 34.4559 158.437C33.9078 158.112 33.0173 157.957 31.7498 157.957H30.6536V162.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8349 162.565H50.7098L49.5623 165.905H44.2356L51.532 146.705H56.9785L64.292 165.905H58.9653L57.8349 162.565ZM56.4989 158.78L54.2552 152.391L52.0115 158.78H56.4989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5515 154.121H81.7623V146.705H86.7636V165.905H81.7623V157.992H74.5515V165.905H69.5674V146.705H74.5515V154.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8372 165.905V146.705H104.816V150.935H98.8213V165.905H93.8372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.183 162.565H115.059L113.911 165.905H108.584L115.898 146.705H121.344L128.657 165.905H123.331L122.183 162.565ZM120.865 158.78L118.621 152.391L116.377 158.78H120.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.917 165.905H133.933V146.705H141.88C144.038 146.705 145.682 147.27 146.83 148.383C147.977 149.496 148.543 151.09 148.543 153.127C148.543 155.165 147.977 156.741 146.83 157.872C145.682 159.002 144.021 159.55 141.88 159.55H138.917V165.905ZM138.917 155.525H140.578C142.411 155.525 143.336 154.721 143.336 153.127C143.336 151.534 142.411 150.73 140.578 150.73H138.917V155.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.966 161.674C155.617 161.674 156.027 161.486 156.233 161.109C156.438 160.732 156.524 160.167 156.524 159.448V146.705H172.265V161.674H174.679V169.485H169.712V165.887H158.169V169.485H153.202V161.674H154.966ZM167.263 150.935H161.509V159.499C161.509 159.995 161.491 160.407 161.474 160.749C161.44 161.091 161.389 161.4 161.303 161.691H167.263V150.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2568 47.2742H22.1155L35.9269 57.7615H59.66L63.2568 47.2742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7922 74.9173L61.9232 77.5341L62.7922 74.9173Z",
    fill: "#3DF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.744 47.2742L115.33 57.7615H139.073L152.885 47.2742H111.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.654 64.248L120.231 72.1187L130.314 64.248H117.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2554 64.248L54.679 72.1187L44.5957 64.248H57.2554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.697 124.91L87.4952 0L46.3033 124.91L62.0143 113.745L87.4952 33.7759L112.552 113.442L128.697 124.91Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6678 84.7884L87.7173 81.6968L83.3527 85.0107L77.6947 102.763L87.7173 95.6496L97.3055 102.459L91.6678 84.7884Z",
    fill: "#DA291C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7949 206.2H61.7441V202H49.2617V186.596H52.7314V199.035H59.1123V186.596H62.5928V199.035H64.7949V206.2ZM78.0684 202H68.8301V186.596H77.7139V189.421H72.2998V192.848H77.3379V195.662H72.2998V199.186H78.0684V202ZM95.3701 202H91.8896V195.727H85.5088V202H82.0391V186.596H85.5088V192.74H91.8896V186.596H95.3701V202ZM111.222 189.421H106.828V202H103.348V189.421H98.9756V186.596H111.222V189.421ZM118.265 196.693V202H114.795V186.596H120.23C124.112 186.596 126.053 188.232 126.053 191.505C126.053 193.052 125.494 194.305 124.377 195.265C123.267 196.217 121.781 196.693 119.919 196.693H118.265ZM118.265 189.26V194.062H119.629C121.477 194.062 122.4 193.252 122.4 191.634C122.4 190.051 121.477 189.26 119.629 189.26H118.265Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.359,
    height: 170,
    fill: "white",
    transform: "translate(0.320557)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvangardLogo);
export default __webpack_public_path__ + "static/media/avangard-logo.430814a3.svg";
export { ForwardRef as ReactComponent };